import { render } from "./ForaDeEscala.vue?vue&type=template&id=2be2c15f"
import script from "./ForaDeEscala.vue?vue&type=script&lang=js"
export * from "./ForaDeEscala.vue?vue&type=script&lang=js"

import exportComponent from "/Users/bhfagundes/Desktop/mobs2/operacoes-front-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__